import React, {FC, useState} from 'react';
import useCustomer from '../../../hooks/use-customer';
import Button from "../../button";
import CheckboxField from "../../checkbox-field";

const VidaSubscriptionAccess: FC = () => {
  const customer = useCustomer();
  const [confirmed, setConfirmed] = useState(false);

  if (!customer) {
    return null;
  }

  if (customer.customer?.guest) {
    return (
      <p data-cy="login-required-vida">
        You must be logged in to purchase a VIDA subscription. If you have been
        on this site before, please use your existing account information or use
        the forgot password link.
      </p>
    );
  }

  return (
    <div className="purchase-vida">
      <p>
        <strong>
          When purchasing a Volvo VIDA license, the email address cannot be the
          same as you use for any existing VIDA CDS ID / any other manufacturer
          (i.e. Polestar). For example, if myname@gmail.com was used to purchase
          a VIDA license in the past, but not for Volvo, then it cannot be used
          for this purchase and you will need to create a new email address for
          this purpose. If you have purchased a Volvo VIDA license in the past,
          be sure to use your same account and email for any new/future
          purchases as well - please DO NOT create another account if you
          already have an existing account.
        </strong>
      </p>
      <p>
        <strong>
          VIDA purchased through the Volvo Bookstore is ONLY for use in North America for North American market cars.
          Use of this product to remotely service cars, especially outside of North America is Strictly Prohibited.
          Unauthorized use shall be cause for immediate termination of access without notice. Any such misuse may result
          in additional civil and/or criminal legal action. Upon termination, the Service will immediately be disabled.
          You will not be refunded any portion of the purchase price already paid. See VIDA License Agreement for
          additional information.
        </strong>
      </p>
      <p style={{ color: 'red' }}>
        <strong>
          Vehicle Technical Support
        </strong>
      </p>
      <p style={{ color: 'red' }}>
        Primarily, we are an administrative help desk providing support with obtaining access to Volvo’s repair and
        diagnostic information. This includes VIDA, Technical Journals and other service business information. Other
        examples of our help support include account set up, purchasing support, advising on computer requirements,
        obtaining usernames and passwords, etc.
      </p>
      <p style={{ color: 'red' }}>
        It is important to note that we are NOT able to provide vehicle repair or technical support, as our team does
        not have this training or experience. All information concerning the steps to repair our vehicles is derived
        from VIDA and published Technical Journals.
      </p>
      <p style={{ color: 'red' }}>
        Finally, VIDA is designed to comply with the J-2534-2 standard, therefore aftermarket scan tools are compatible
        with our system and our vehicles.
      </p>
      <CheckboxField
        id="confirmation"
        label="I understand this information and I am only using this in North America for North American market vehicles and all technical support is for access and account information only."
        checked={confirmed}
        onChange={(e) => setConfirmed(e.target.checked)}
      />
      {confirmed &&
        <Button text="View License Agreement and Purchase Subscription"
                onClick={() => window.location.href = "/vida/subscription"}/>
      }
      {/* language=CSS */}
      <style jsx>
        {`
          .purchase-vida {
            margin: 20px 0 0 0;
          }
        `}
      </style>
    </div>
  );
};

export default VidaSubscriptionAccess;
